<template>
    <div class="flag">
    </div>
</template>

<script>
export default {
    name: "Flag",
};
</script>

<style lang="scss" scoped>
@import '~@/styles/rem';

.flag {
    width: 24px;
    height: 24px;
    background: url("~@/assets/images/account-track/icon/competences/flag.svg") no-repeat center/contain;

    @include on-xs {
        width: 22px;
        height: 22px;
    }

}
</style>